import { useEffect, useMemo, useRef, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ORGANIZATION_ITEMS } from '../graphql';
import { prepareDynamicDataFromBackendFacets } from '../utils';
import useGetFacetsData from './useGetFacetsData';

const useOrganizationItems = ({
    variables,
    selectedCategoryIds,
    onDataFetched  // callback for parent to handle data
}) => {
    // states
    const [otherMatchBarOptions, setOtherMatchBarOptions] = useState({});
    const [matchBarDynamicFields, setMatchBarDynamicFields] = useState([]);

    const { categories } = useGetFacetsData();

    const { loading, data, fetchMore, refetch } = useQuery(
        GET_ORGANIZATION_ITEMS,
        { variables }
    );

    // onCompleted does not fire on fetchMore, so react to data changes directly.
    // This keeps the UI in sync with the cache-merged paginated results.
    const onDataFetchedRef = useRef(onDataFetched);
    useEffect(() => {
        onDataFetchedRef.current = onDataFetched;
    });

    useEffect(() => {
        if (!data) return;
        const { facets = [] } = data?.searchOrganizationObjects || {};
        const { fields, options } = prepareDynamicDataFromBackendFacets(
            facets,
            categories,
            selectedCategoryIds
        );

        fields.forEach(fieldData => {
            if ((fieldData.id === "categories") && (fields.length === 1)) {
                fieldData.infoText = "Select a category to load filters"
            }
        })

        setOtherMatchBarOptions(options);
        setMatchBarDynamicFields(fields);

        onDataFetchedRef.current && onDataFetchedRef.current(data);
    }, [data, categories, selectedCategoryIds]);

    const showSearchTag = useMemo(() => matchBarDynamicFields.length > 1, [matchBarDynamicFields])
    const tagSearchIndex = useMemo(() => matchBarDynamicFields.findIndex(fieldData => fieldData.id === "categories") + 1, [matchBarDynamicFields])

    return { loading, data, fetchMore, refetch, otherMatchBarOptions, matchBarDynamicFields, showSearchTag, tagSearchIndex };
};

export default useOrganizationItems;